export const MLDomains: { [key: string]: { domainName: string } } = {
  DSG: {
    domainName: 'dickssportinggoods.com',
  },
  GG: {
    domainName: 'golfgalaxy.com',
  },
  FNS: {
    domainName: 'fieldandstreamshop.com',
  },
  CALIA: {
    domainName: 'calia.com',
  },
  VRST: {
    domainName: 'vrst.com',
  },
  PL: {
    domainName: 'publiclands.com',
  },
  MJ: {
    domainName: 'moosejaw.com',
  },
  G3: {
    domainName: 'goinggoinggone.com',
  },
};
